module.exports = __webpack_public_path__ + "img/moon.79dc460d.svg";